import { digObject } from '@domain-group/javascript-utils'
import {
  Box,
  Form,
  Image,
  Link,
  LoadingModule,
  StatusBadge,
  Text,
} from '@domain-group/suit-theme'

import useArtwork from '@hooks/useArtwork'
import useCarousel from '@hooks/useCarousel'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

import ActivityList from '@components/ActivityList'

import ManageArtworkActions from './ManageArtworkActions'

interface ManageArtworkProps {
  orderItemPayload: UseOrderItemPayload,
}

const ManageArtwork = (props: ManageArtworkProps) => {
  const {
    orderItemPayload,
    orderItemPayload: {
      // @ts-expect-error TS2339
      artwork: { id: artworkId },
      artworkApproved,
    },
  } = props

  const artworkPayload = useArtwork({ id: artworkId }, {
    generateUrlsOptions: {
      includeRedirect: true,
    },
    performHttpRequests: !!artworkId,
    requestOptions: {
      include_artwork_artwork_reviews: true,
      include_artwork_page_preview: true,
      include_artwork_pages: true,
    },
  })
  const {
    filteredArtworkPages,
    isUploadedArtwork,
    loading: loadingArtwork,
    updating: updatingArtwork,
  } = artworkPayload

  const pageCount = filteredArtworkPages.length

  const carouselParams = {
    initialIndex: 0,
    items: filteredArtworkPages,
  }
  const carouselPayload = useCarousel(carouselParams)
  const {
    callbacks: {
      selectNext,
      selectPrevious,
    },
    canSelectNext,
    canSelectPrevious,
    selectedIndex,
  } = carouselPayload

  // @ts-expect-error TS2538
  const selectedPage = filteredArtworkPages[selectedIndex]
  const artworkPreviewUrl = digObject(selectedPage, 'previews.preserved_560x560')
  const largeArtworkPreviewUrl = digObject(selectedPage, 'previews.large')

  return (
    <>
      <Box alignItems="center">
        {artworkApproved && (
          <Form.Field label="Status">
            <StatusBadge color="green" text="Approved" />
          </Form.Field>
        )}
      </Box>

      <Form.Field
        direction="column"
        label={pageCount <= 1 ? 'Artwork' : `Artwork (${pageCount} Pages)`}
        marginTop="large"
      >
        <Box alignItems="center" height={343} justifyContent="center" variant="whiteGrey">
          {/* Artwork Preview */}
          <LoadingModule loading={loadingArtwork} />

          {!updatingArtwork && artworkPreviewUrl && (
            <Link href={largeArtworkPreviewUrl} target="_blank">
              <Image backgroundSize="contain" height={343} width={343} url={artworkPreviewUrl} />
            </Link>
          )}

          {/* Custom Artwork - Extracting Pages */}
          {isUploadedArtwork && !artworkPreviewUrl && (
            <Text color="bodyFontLightColor">
              Refresh Page to View Preview
            </Text>
          )}
          {/* End Custom Artwork - Extracting Pages */}
        </Box>

        {pageCount > 1 && (
          <Box
            marginTop="medium"
            style={{ flexDirection: 'row', fontSize: 'small', justifyContent: 'space-between' }}
          >
            <Link
              disabled={!canSelectPrevious}
              onClick={() => selectPrevious()}
              style={{ alignSelf: 'flex-start' }}
            >
              Prev Page
            </Link>

            <Link
              disabled={!canSelectNext}
              onClick={() => selectNext()}
              style={{ alignSelf: 'flex-end' }}
            >
              Next Page
            </Link>
          </Box>
        )}

        {!!artworkId && (
          <ManageArtworkActions
            artworkPayload={artworkPayload}
            orderItemPayload={orderItemPayload}
          />
        )}
      </Form.Field>

      {!!artworkId && (
        <ActivityList artworkPayload={artworkPayload} />
      )}
    </>
  )
}

export default ManageArtwork
